import * as R from 'ramda'

export function openSnackbar(state, action) {
  return R.mergeRight(state, { ...action.payload, open: true })
}

export function closeSnackbar(state) {
  return R.mergeRight(state, { open: false })
}

export function setMessage(state, action) {
  return R.mergeRight(state, { open: true, msg: action.payload })
}
